import axios from "axios";

import { APPLICATION, SESSION_EXPIRE_URL, PRODUCT } from "@/constants";
import logError from "@/utils/logger";

const fetchSessionExpireError = async () => {
  let pageJson: { title?: string; ctaButtonText?: string } | null = {};
  await axios
    .get(`${SESSION_EXPIRE_URL}/${PRODUCT}-${APPLICATION}`)
    .then(async (res) => {
      pageJson = {
        title: res.data.titleText,
        ctaButtonText: res.data.ctaButtonText1,
      };
    })
    .catch((e) => {
      logError(e, { location: "fetchSessionExpire.tsx" });
      pageJson = null;
    });

  return pageJson;
};

export default fetchSessionExpireError;
